// components/StudentPortal/StudentShell/StudentShell.js
// Carcasa del Portal del Alumno (F3). Header propio (logo + chip de modo +
// idioma + salir) y cuerpo donde F4 montara el Home "Hoy". El tema (claro vs
// oscuro/VR) se resuelve por el modo: clase .vr aplica el set oscuro.
// El chip de modo permite "cambiar modo" (vuelve a S0 via clearMode).
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Logout, LanguageSwitcher } from "../../Admin/AdminLayout";
import { useStudentModeStore } from "../../../store/studentModeStore";
import { logoEduca } from "../../../assets";
import { StudentHome } from "../Home/StudentHome";
import { StudentHomeVR } from "../Home/StudentHomeVR";
import { StudentTaskWizard } from "../Task/StudentTaskWizard";
import styles from "./StudentShell.module.scss";

export function StudentShell({ mode }) {
  const { t } = useTranslation("students");
  const clearMode = useStudentModeStore((s) => s.clearMode);
  const isVr = mode === "vr";
  // Navegacion interna del portal (sin router aparte): home <-> wizard de tarea.
  const [openTaskId, setOpenTaskId] = useState(null);

  return (
    <div className={`${styles.shell} ${isVr ? styles.vr : styles.screen}`}>
      <header className={styles.header}>
        <img src={logoEduca.logoE360} alt="Educa360" className={styles.logo} />
        <div className={styles.right}>
          <button
            type="button"
            className={styles.modeChip}
            onClick={clearMode}
            title={t("mode.change")}
          >
            {t("mode.chip")}: {isVr ? t("mode.vr") : t("mode.screen")}
          </button>
          <LanguageSwitcher />
          <Logout />
        </div>
      </header>

      <main className={styles.body}>
        {/* Home "Hoy" (S1, F4) <-> Wizard de tarea (S2, F5). La variante
            VR-optimizada es F8; en modo VR se ve sobre el shell oscuro. */}
        {openTaskId ? (
          <StudentTaskWizard
            taskId={openTaskId}
            mode={mode}
            onBack={() => setOpenTaskId(null)}
          />
        ) : isVr ? (
          <StudentHomeVR />
        ) : (
          <StudentHome onOpenTask={setOpenTaskId} />
        )}
      </main>
    </div>
  );
}
